import type { Nullable } from "../types";
import { getFullName } from "./get-full-name";

/**
 * This function is used to create initials for a given name.
 * @param item
 * @returns
 */
export function getInitials<
	T extends
		| {
				firstName?: Nullable<string>;
				lastName?: Nullable<string>;
		  }
		| {
				first_name?: Nullable<string>;
				last_name?: Nullable<string>;
		  },
>(item: Nullable<T>) {
	const fullName = getFullName(item);
	const splitted = fullName.split(" ").map((seg) => seg.charAt(0));
	return splitted.join("");
}
